var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SiteCallToAction"},[_c('h2',[_vm._v("Digitalize your tickets today.")]),_c('Button',{staticClass:"primary lg",attrs:{"to":"/signup"}},[_vm._v("Try DumpTek Free")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }